import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-right-nav',
  templateUrl: './right-nav.component.html',
  styleUrls: ['./right-nav.component.scss'],
})
export class RightNavComponent implements OnInit {
  hasBets = false; // Mocking bet slip state for now

  ngOnInit(): void {}

  toggleBet() {
    this.hasBets = !this.hasBets;
  }
}
